import SchoolOptionsAdapter from './base';

export default class Field extends SchoolOptionsAdapter {
  modelNamePlural = 'options';

  pathForType(type) {
    type = type.replace(/^school-options\/fields?/, `schema/options`);
    return type;
  }
}
